import { ApiError } from '../client'

/** 429 from POST /api/v1/health/run: one manual run per 60 s for the whole team. */
export class HealthRateLimited extends ApiError {
  constructor(
    message: string,
    readonly retryAfterS: number,
  ) {
    super(429, message)
    this.name = 'HealthRateLimited'
  }
}
